/**
 * SHEIN 工作区常见问题（帮助中心静态条目，可按关键词检索）。
 * @typedef {{ id: string, category: string, title: string, answer: string, keywords?: string[] }} SheinFaqItem
 */

/** @type {SheinFaqItem[]} */
export const SHEIN_NOTICE_FAQ_ITEMS = [
  {
    id: 'faq-auth',
    category: '店铺授权',
    title: '店铺显示未授权或授权失效怎么办？',
    answer: '请到「店铺信息」确认授权状态。若已过期，重新完成 SHEIN 开放平台授权后刷新工作区。授权异常也会出现在系统通知中。',
    keywords: ['授权', '未授权', 'oauth', 'token', '店铺'],
  },
  {
    id: 'faq-sync',
    category: '同步更新',
    title: '同步更新失败或进度条中断？',
    answer: '先确认当前店铺已授权。可在对应业务页（商品 / 证书 / 合规 / 财务 / 订单）再次点击「拉取 SHEIN 后台数据」。若持续失败，查看系统通知中的同步异常说明。',
    keywords: ['同步', '进度', '失败', '中断', '刷新'],
  },
  {
    id: 'faq-todo-local',
    category: '合规资质',
    title: '待办事项的数字和产品合规不一致？',
    answer: '首页「合规资质待办」的「拉取 SHEIN 后台数据」只重算本地已入库数据，不会再次拉取平台。请先在「产品合规 / 合规资料」完成平台同步，再回到首页刷新。',
    keywords: ['待办', '首页', '本地', '入库', '证书缺失', '合规'],
  },
  {
    id: 'faq-cert',
    category: '合规资质',
    title: '证书缺失 / 即将过期如何处理？',
    answer: '进入「产品合规 → 证书绑定」，按筛选上传或绑定证书。即将过期可在「即将过期」筛选项中集中处理。',
    keywords: ['证书', '过期', '补证', '资质'],
  },
  {
    id: 'faq-label',
    category: '合规资质',
    title: '实拍图 / 标签待补在哪里处理？',
    answer: '进入「产品合规 → 实拍图」。同步时把平台返回了实拍识别要求的 SKC 写入本地（待补充 / 审核中 / 审核通过都入库）；无要求的不落库。列表上方可按审核维度切换，列「审核状态」来自平台 reviewStatus。',
    keywords: ['实拍', '标签', 'SKC', '补全'],
  },
  {
    id: 'faq-agency',
    category: '合规资质',
    title: '代理（欧代 / 英代 / 美代）如何绑定？',
    answer: '进入「产品合规 → 代理绑定」，选择未绑定 SKC 完成代理绑定。代理公司列表可在「合规资料 → 公司代理」查看；绑定前请先同步合规数据。',
    keywords: ['代理', '欧代', '英代', '美代', '绑定', '代理绑定', '绑定公司'],
  },
  {
    id: 'faq-finance',
    category: '财务账单',
    title: '财务账单同步不到数据？',
    answer: '确认店铺类型（自运营 / 半托管）与账单类型（对账单 / 报告）选择正确，并使用合理的时间范围同步。超长区间请缩小后再试。',
    keywords: ['财务', '账单', '对账', '报告'],
  },
  {
    id: 'faq-return',
    category: '退货退款',
    title: '退货单列表为空或详情不全？',
    answer: '先在「订单管理 > 退货退款」页按时间范围「拉取 SHEIN 后台数据」。详情优先读本地缓存；若仍不全，可在详情页刷新以强制拉取平台。',
    keywords: ['退货', '退款', '售后', '详情'],
  },
  {
    id: 'faq-notice',
    category: '通知',
    title: '平台通知和系统通知有什么区别？',
    answer: '平台通知侧重核价、平台推送等业务提醒；系统通知侧重店铺授权、同步异常等。打开对应铃铛后，推送与同步类会记为已读并去掉角标，业务待办会一直留在角标里直到事项处理完。单条也可点 × 关闭；完整列表与常见问题请打开「帮助」。',
    keywords: ['通知', '平台', '系统', '角标'],
  },
  {
    id: 'faq-feedback',
    category: '问题反馈',
    title: '遇到无法自行解决的问题如何反馈？',
    answer: '在本帮助页切换到「问题反馈」，填写联系邮箱与问题描述后提交。反馈会发送到系统已配置的收件邮箱；请尽量附上店铺名、操作路径与大致时间，便于排查。',
    keywords: ['反馈', '客服', '报错', '建议'],
  },
];
